// maomi/src/components/NavSplide.js

import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import './css/NavSplide.css';

function NavSplide() {
    return (
        <div className="splide-wrapper">
            <Splide
                options={{
                    type: 'fade',
                    padding: '10rem',
                    height: '400px',
                    rewind: true,
                    autoplay: true,
                    interval: 2000,
                }}
            >
                <SplideSlide>
                    <div className="row">
                        <div className="col-sm-4">
                            <img src={require('./img/Designer (1).jpeg')} className="rounded" alt="Cat Registration" />
                        </div>
                        <div className="col-sm-8">
                            <div className="SplideText SplideTitle">猫咪注册</div>
                            <div className="SplideText SplideContent">
                                加入猫咪家并注册您的猫咪，免费领取专属于TA的身份号牌 ❘❚❙❘❚❘❚❘❘❘❚❘❘❚❘❘❘❚，谨防爱宠走失，利用机器学习+庞大互助社区协助猫咪找回，获取AI宠物医生专业健康咨询，与其他猫咪爱好者分享经验，探索养宠乐趣。🐾
                            </div>
                        </div>
                    </div>
                </SplideSlide>
                <SplideSlide>
                    <div className="row">
                        <div className="col-sm-4">
                            <img src={require('./img/Designer (6).jpeg')} className="rounded" alt="Lost and Found" />
                        </div>
                        <div className="col-sm-8">
                            <div className="SplideText SplideTitle">丢失找回</div>
                            <div className="SplideText SplideContent">
                                利用注册时猫咪的身纹、声音、主人呼唤录音等身份信息借助机器学习匹配数据库中的猫咪，并借助庞大互助社区协助猫咪找回。猫咪也是我们的家庭成员，猫咪家与您一同守护每一只可爱的小生命，让猫咪早日回家！
                            </div>
                        </div>
                    </div>
                </SplideSlide>
                <SplideSlide>
                    <div className="row">
                        <div className="col-sm-4">
                            <img src={require('./img/Designer (2).jpeg')} className="rounded" alt="Cat Forum" />
                        </div>
                        <div className="col-sm-8">
                            <div className="SplideText SplideTitle">猫咪论坛</div>
                            <div className="SplideText SplideContent">
                                与全国猫奴们一起分享喵喵趣闻！交流猫咪饲养方法、护理技巧、健康建议，分享可爱猫咪的照片和视频以及感人故事。
                            </div>
                        </div>
                    </div>
                </SplideSlide>
                <SplideSlide>
                    <div className="row">
                        <div className="col-sm-4">
                            <img src={require('./img/Designer (3).jpeg')} className="rounded" alt="AI Health Consultation" />
                        </div>
                        <div className="col-sm-8">
                            <div className="SplideText SplideTitle">免费AI云诊所</div>
                            <div className="SplideText SplideContent">
                                基于动物专业医学文献及医疗案例的AI模型，协助您实时监测猫咪的健康状况，并提供个性化的医疗建议和预防措施。科技赋能护理，让每一只猫咪都能获得免费且及时的医疗咨询服务。
                            </div>
                            <div className="SplideText SplidePs">*AI模型不能代替医师，仅提供健康咨询，紧急情况下请咨询专业兽医</div>
                        </div>
                    </div>
                </SplideSlide>
                <SplideSlide>
                    <div className="row">
                        <div className="col-sm-4">
                            <img src={require('./img/Designer (4).jpeg')} className="rounded" alt="Cute Pet Stories" />
                        </div>
                        <div className="col-sm-8">
                            <div className="SplideText SplideTitle">萌宠趣闻</div>
                            <div className="SplideText SplideContent">
                                为您搜集全世界各种有趣、感人和令人心动的萌宠故事，充满欢乐和温馨。
                            </div>
                        </div>
                    </div>
                </SplideSlide>
                <SplideSlide>
                    <div className="row">
                        <div className="col-sm-4">
                            <img src={require('./img/Designer (5).jpeg')} className="rounded" alt="No More Strays" />
                        </div>
                        <div className="col-sm-8">
                            <div className="SplideText SplideTitle">不再流浪</div>
                            <div className="SplideText SplideContent">
                                获取和分享领养信息，给流浪猫一个永远的家；或者提供寄养、捐助，为它们提供食物、医疗和爱心。让爱传递，为流浪猫找到安全、温馨的家。
                            </div>
                        </div>
                    </div>
                </SplideSlide>
            </Splide>
        </div>
    );
}

export default NavSplide;
